import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { BaseControlComponent } from "../base-control/base-control.component";
import { ContextInteractionService } from "../../services/context-interaction.service";

@Component({
    selector: 'app-list-entry',
    templateUrl: './list-entry.component.html',
    styleUrls: ['./list-entry.component.scss'],
    standalone: false
})
export class ListEntryComponent extends BaseControlComponent implements OnInit, OnDestroy {
    static componentName = "ListEntryComponent";

    get buttonLabel(): string {
        let value: string = "Add to List";
        if (this.componentData && this.componentData.config && this.componentData.config.buttonLabel) {
            value = this.componentData.config.buttonLabel;
        }
        return value;
    }

    get disableButton(): boolean {
        return this.isEdit || !this.isEnabled;
    }

    get listItems(): string[] {
        let data = this.getContextValue();
        if (data == null) {
            data = [];
            this.setContextValue(data);
        }
        if (!(Array.isArray(data))) {
            data = [data.toString()];
            this.setContextValue(data);
        }
        
        return data;
    }

    enabledSub: Subscription = new Subscription();

    constructor(public readonly contextService: ContextInteractionService) {
        super(contextService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.formGroup.addControl("inputValue", new FormControl(""));  
        this.enabledSub = this.enabledObs$.subscribe(
            (enable) => {
                let ctrl = this.formGroup.get("inputValue");
                if (enable) ctrl.enable();
                else ctrl.disable();
            },
            (error) => { console.error(error); });
    }

    ngOnDestroy() {
        if (this.enabledSub) this.enabledSub.unsubscribe();
    }

    add(): void {
        let ctrl = this.formGroup.get("inputValue");
        if (ctrl) {
            let value = ctrl.value;
            this.listItems.push(value);
            ctrl.patchValue("");
        }
        this.setContextValue(this.listItems);
    }

    remove(index: number): void {
        this.listItems.splice(index, 1);
        this.setContextValue(this.listItems);
    }

}
